import { APP_COUNTRY, AR_SESSION_TIME_DOMAIN } from 'config';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSessionInfo } from 'services/session/session.requests';
import { selectSessionInfo } from 'services/session/session.selectors';

const SessionTimerIframeForPT = () => {
  const src = `${AR_SESSION_TIME_DOMAIN}session-timer/timer.html?channel=62&revealAfterSeconds=`;
  const isPortugal = APP_COUNTRY === 'pt';
  const isSpain = APP_COUNTRY === 'es';
  const [jwt, setJwt] = useState<string | null | undefined>(null);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { channel } = useSelector(selectSessionInfo);

  const getAuthToken = async () => {
    const sessionInfo = await getSessionInfo();
    if (sessionInfo) {
      setJwt(sessionInfo?.auth?.authToken);
    }
  };

  useEffect(() => {
    getAuthToken();
  }, []);

  useEffect(() => {
    if (!jwt) return;
    const listener = (event: MessageEvent) => {
      if (event.data?.type === 'REQUEST_USER') {
        const responseData = {
          type: 'USER_RESPONSE',
          jwtToken: jwt,
          channel,
        };
        event.source?.postMessage(responseData, { targetOrigin: '*' });
      }
    };

    window.addEventListener('message', listener);

    return () => window.removeEventListener('message', listener);
  }, [jwt, channel]);

  return (isPortugal || isSpain) && jwt ? (
    <div
      className="sessionTimerContainer js-session-timer"
      style={{ display: isSpain ? 'none' : 'block' }}
    >
      <iframe
        ref={iframeRef}
        id="sessionTimerIframe"
        style={{ border: 'none', height: '50px', width: '100vw' }}
        src={src}
      />
    </div>
  ) : null;
};

export default SessionTimerIframeForPT;
